import React from "react";
import { Link } from "react-router-dom";
import { canUseCatalogue } from "../../helpers/catalogueEnabled";
import { readAuthUser } from "../../helpers/studioModules";
import "./StudioGetStarted.scss";

/** First-run next steps for a studio that has no products yet. */
const StudioGetStarted = () => {
  const authUser = readAuthUser();
  const role = authUser?.users?.role;
  if (role !== "ORGANIZATION_ADMIN" && role !== "ORGANIZATION_MANAGER") return null;
  const showCatalogue = canUseCatalogue(role);

  return (
    <section className="studio-get-started" aria-labelledby="studio-get-started-title">
      <h2 id="studio-get-started-title">Get started with Studio</h2>
      <ol>
        <li>
          <div>
            <strong>Add your first product</strong>
            <span>Photos, artform, and process steps make its record and certificate.</span>
          </div>
          <Link className="studio-get-started__primary" to="/createProduct">
            Add product
          </Link>
        </li>
        {role === "ORGANIZATION_ADMIN" && (
          <li>
            <div>
              <strong>Complete organisation details</strong>
              <span>GST, address, and logo appear on catalogues and invoices.</span>
            </div>
            <Link to="/edit-profile-organisation-details">Add details</Link>
          </li>
        )}
        {showCatalogue && (
          <li>
            <div>
              <strong>Share a catalogue</strong>
              <span>Group published pieces and send buyers one link.</span>
            </div>
            <Link to="/catalogue">Open catalogue</Link>
          </li>
        )}
      </ol>
    </section>
  );
};

export default StudioGetStarted;
